(function () {
  'use strict';

  if (window.DevidCartDrawerV3) return;

  var refreshTimer = null;
  var hydrationTimer = null;
  var lastImpressionKey = '';
  var lastCart = null;
  var requestInFlight = false;
  var interactionLockUntil = 0;

  function rootUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  function analytics(name, detail) {
    if (window.DevidCommerceAnalytics && typeof window.DevidCommerceAnalytics.publish === 'function') {
      window.DevidCommerceAnalytics.publish(name, detail || {});
    }
  }

  function fixDestinations(drawer) {
    var emptyCta = drawer.querySelector('.cart-drawer__empty-cta');
    if (emptyCta && emptyCta.getAttribute('href') !== rootUrl()) {
      emptyCta.href = rootUrl();
    }

    var sprayground = drawer.querySelector('[data-upsell-suggestion="altri-prodotti-sprayground"]');
    if (sprayground) {
      sprayground.href = rootUrl() + 'collections/sprayground';
      sprayground.setAttribute('data-suggestion-type', 'collection');
    }

    var kway = drawer.querySelector('[data-upsell-suggestion="accessori-k-way"]');
    if (kway) {
      kway.href = rootUrl() + 'collections/k-way';
      kway.setAttribute('data-suggestion-type', 'collection');
    }
  }

  function hasBundle(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return item && item.properties && item.properties._bundle_id;
    }));
  }

  function productIds(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(function (item) { return item.product_id; }).filter(Boolean);
  }

  function applyCartState(cart) {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;

    if (!drawer.classList.contains('cart-drawer--v3')) {
      drawer.classList.add('cart-drawer--v3');
    }

    fixDestinations(drawer);

    if (!cart) return;

    lastCart = cart;
    var bundled = hasBundle(cart);

    if (drawer.classList.contains('cart-drawer--has-bundle') !== bundled) {
      drawer.classList.toggle('cart-drawer--has-bundle', bundled);
    }

    var bundleValue = bundled ? 'true' : 'false';
    if (drawer.dataset.cartHasBundle !== bundleValue) {
      drawer.dataset.cartHasBundle = bundleValue;
    }

    var engine = drawer.querySelector('[data-upsell-engine-root]');
    if (!engine || bundled) return;

    var firstCard = engine.querySelector('[data-upsell-suggestion]');
    if (!firstCard) return;

    var key = [
      engine.getAttribute('data-upsell-rule-id') || '',
      firstCard.getAttribute('data-upsell-suggestion') || '',
      productIds(cart).join('-')
    ].join('|');

    if (key !== lastImpressionKey) {
      lastImpressionKey = key;
      analytics('cart_upsell_viewed', {
        rule_id: engine.getAttribute('data-upsell-rule-id') || '',
        suggestion: firstCard.getAttribute('data-upsell-suggestion') || '',
        suggestion_type: firstCard.getAttribute('data-suggestion-type') || '',
        cart_item_count: cart.item_count || 0,
        cart_value: cart.total_price || 0
      });
    }
  }

  function scheduleApply(cart) {
    if (cart) lastCart = cart;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      applyCartState(lastCart);
    }, 0);
  }

  async function hydrateCartState() {
    if (requestInFlight) return;

    if (Date.now() < interactionLockUntil) {
      scheduleIdleHydration();
      return;
    }

    requestInFlight = true;

    try {
      var response = await fetch(rootUrl() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('cart_state_' + response.status);
      scheduleApply(await response.json());
    } catch (error) {
      var drawer = document.querySelector('#cart-drawer');
      if (drawer) drawer.dataset.cartV3State = 'fallback';
    } finally {
      requestInFlight = false;
    }
  }

  function scheduleIdleHydration() {
    window.clearTimeout(hydrationTimer);

    hydrationTimer = window.setTimeout(function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(hydrateCartState, { timeout: 3000 });
      } else {
        hydrateCartState();
      }
    }, 1200);
  }

  function lockCartRequests() {
    interactionLockUntil = Date.now() + 1800;
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.target && event.target.closest && event.target.closest('form[action*="/cart/add"], #cart-drawer')) {
      lockCartRequests();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var card = target.closest('#cart-drawer [data-upsell-suggestion]');
    if (card) {
      var engine = card.closest('[data-upsell-engine-root]');
      analytics('cart_upsell_clicked', {
        rule_id: engine ? (engine.getAttribute('data-upsell-rule-id') || '') : '',
        suggestion: card.getAttribute('data-upsell-suggestion') || '',
        suggestion_type: card.getAttribute('data-suggestion-type') || '',
        destination: card.getAttribute('href') || ''
      });
      return;
    }

    var checkout = target.closest('#cart-drawer button[name="checkout"], #cart-drawer [name="checkout"]');
    if (checkout) {
      var drawer = document.querySelector('#cart-drawer');
      analytics('cart_checkout_clicked', {
        has_bundle: drawer && drawer.dataset.cartHasBundle === 'true'
      });
    }
  });

  document.addEventListener('variant:add', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    scheduleApply(cart);
  });

  document.documentElement.addEventListener('cart:change', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    scheduleApply(cart);
  });

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.type === 'childList'; })) {
      scheduleApply(lastCart);
    }
  });

  function start() {
    var drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;

    observer.observe(drawer, { childList: true, subtree: true });
    applyCartState(null);
    scheduleIdleHydration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.DevidCartDrawerV3 = {
    refresh: function (cart) {
      if (cart) {
        scheduleApply(cart);
        return;
      }
      scheduleIdleHydration();
    }
  };
})();
